import { ILayoutElement } from "@faire/web-api/indigofair/data/ILayoutElement";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React from "react";
import styled, { css } from "styled-components";

import { LayoutElementBasedCarousel } from "@faire/retailer/components/LayoutElementRenderer/LayoutElementBasedCarousel";
import { TitleStyles } from "@faire/retailer/components/LayoutElementRenderer/styles/TitleStyles";

const MAX_ITEMS_MOBILE = 3;
const MAX_ITEMS_TABLET = 5;
const MAX_ITEMS_DESKTOP = 8;

export const BrandPageLayoutElementRenderer: React.FC<{
  layoutElement: ILayoutElement;
  tilesLength: number;
  onItemClick?: () => void;
}> = ({ layoutElement, tilesLength, onItemClick }) => {
  const itemsPerSlide = useResponsiveValue({
    mobileAndAbove: Math.min(MAX_ITEMS_MOBILE, tilesLength),
    tabletAndAbove: Math.min(MAX_ITEMS_TABLET, tilesLength),
    desktopAndAbove: Math.min(MAX_ITEMS_DESKTOP, tilesLength),
  });

  return (
    <StyledCarouselWrapper $itemsPerSlide={itemsPerSlide}>
      <LayoutElementBasedCarousel
        layoutElement={layoutElement}
        // currently visual nav layout element is hard coded in FE
        // there is no requestId yet
        requestId=""
        itemsPerSlide={itemsPerSlide}
        onItemClick={onItemClick}
      />
    </StyledCarouselWrapper>
  );
};

const StyledCarouselWrapper = styled.div<{
  $itemsPerSlide: number;
}>`
  min-width: 0;

  --item-per-slide: ${(props) => props.$itemsPerSlide};
  ${responsiveMediaQueries.mobile} {
    ${TitleStyles.Container} {
      padding-left: 20px;
    }
  }

  ${responsiveMediaQueries.tabletAndAbove} {
    ${TitleStyles.Container} {
      align-items: center;
    }
  }

  ${responsiveMediaQueries.tablet} {
    ${(props) =>
      props.$itemsPerSlide === MAX_ITEMS_TABLET
        ? css`
            width: calc(
              88px * var(--item-per-slide) + 16px * (var(--item-per-slide) - 1)
            );
          `
        : null}
  }

  ${responsiveMediaQueries.desktopAndAbove} {
    ${(props) =>
      props.$itemsPerSlide === MAX_ITEMS_DESKTOP
        ? css`
            width: calc(
              88px * var(--item-per-slide) + 16px * (var(--item-per-slide) - 1)
            );
          `
        : null}
  }
`;
